<template>
  <BaseButton
    text
    color="white"
    retain-focus-on-click
    :ripple="false"
    @click="launchIlmEditor()"
  >
    <BaseSpriteIcon icon-name="ico-toolbar-studyproject"></BaseSpriteIcon>
    <span class="context-menu-text-item">{{
      $t('Context.short.correct')
    }}</span>
  </BaseButton>
</template>

<script>
import BaseSpriteIcon from '@/components/base/BaseSpriteIcon/BaseSpriteIcon.vue';
import BaseButton from '@/components/base/BaseButton/BaseButton';

export default {
  name: 'ILMControl',
  components: {
    BaseSpriteIcon,
    BaseButton
  },
  computed: {
    selectedLocator() {
      return this.$store.getters['MaterialsStore/getSelectedLocator'];
    },
    meta() {
      return this.$store.getters['PublicationStore/getMeta']();
    }
  },
  methods: {
    launchIlmEditor() {
      const url = this.$store.getters['BookStore/getFullIlmUrl'](
        this.meta.ilmId,
        this.selectedLocator
      );

      this.$store.dispatch('ContextStore/openUrl', { url });
    }
  }
};
</script>
